import { Tag } from 'nhsuk-react-components';
import { formatStatus, getStatusColour } from 'utils/formattingUtils.ts';
import { ITERATION_STATUS } from 'schemas/CampaignApiDetails.schema.ts';
import { SUMMARY_REPORT_REVIEW_STATUSES } from 'schemas/SummaryReport.schema.ts';

interface IReportStatusProps {
  status: ITERATION_STATUS|SUMMARY_REPORT_REVIEW_STATUSES;
}

export default function StatusTag({ status }: IReportStatusProps) {
  const color = getStatusColour(status);

  return <Tag color={color}>{formatStatus(status ?? '')}</Tag>;
}
